module.exports = __webpack_public_path__ + "media/images/logos/logo_small-98acf0c2abfd4f78cc49ac359a951aba.svg";